'use strict';
import {AjaxFactory} from '../AjaxFactory';
import {HttpMethod} from '../enums';
import {getQueryParams} from './defaultItemFactory';


/**
 * @param {ReduxObservableItemOptions} options
 */
export function buildSyncItemFactory(options) {
  return new AjaxFactory(buildItemSyncRequestOptions(options));
}

/**
 * @param {ReduxObservableItemOptions} options
 * @return {AjaxFactoryOptions}
 */
export function buildItemSyncRequestOptions(options) {
  return {
    crossDomain: options.crossDomain,
    method: HttpMethod.GET,
    useBody: false,
    url: getItemSyncUrl(options),
    getToken: options.getToken,
    modifyHeaders,
  };
}

/**
 * @typedef {ItemRequest} ItemSyncRequest
 * @property {String} id
 * @property {Object} headers
 * @property {String} headers.ETag
 */

/**
 * @param {ReduxObservableItemOptions} options
 * @return {Function}
 */
export function getItemSyncUrl(options) {
  /**
   * @param {ItemSyncRequest} request
   */
  return function getItemUrlCurried(request) {
    return `${options.baseApiUrl}/${getItemSyncPath(options, request.id)}${getQueryParams(options, request)}`;
  }
}

/**
 * @param {ReduxObservableItemOptions} options
 * @param {String} id
 * @return {String}
 */
function getItemSyncPath(options, id) {
  return options.itemSyncPath(id);
}

/**
 *
 * @param headers
 * @param {ItemSyncRequest} request
 */
function modifyHeaders(headers, request) {
  headers.ETag = request.headers.ETag;
  return headers;
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/item/defaultSyncItemFactory.js